import React, { useEffect } from "react";
import { NavStyles, HeaderStyles, CampaignStyles } from "styles/style";
import logo from "../../images/lra.svg";
import { ReactComponent as MenuIcon } from "feather-icons/dist/icons/menu.svg";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
import useAnimatedNavToggler from "helpers/useAnimatedNavToggler";
import { api } from "supabase/database/api.ts";


export default ({
	links = [],
	className,
	collapseBreakpointClass = "lg",
	logoIcon = logo,
}) => {
	const { showNavLinks, animation, toggleNavbar } = useAnimatedNavToggler();
	const collapseBreakpointCss = NavStyles.collapseBreakPointCssMap[collapseBreakpointClass];
	const [campaign, setCampaign] = React.useState(null);

	// Preload the logo image once we have the campaign
	useEffect(() => {
		async function getCampaign() {
			const data = await api.heavenlyCultureCampaignQueries.getActiveCampaigns();
			setCampaign(data)
			return data;
		}
		const campaign = getCampaign();
		if (campaign?.logo) {
			const link = document.createElement('link');
			link.rel = 'preload';
			link.as = 'image';
			link.href = `https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/${campaign.logo}.png`;
			document.head.appendChild(link);
		}
	}, [campaign]);

	var logoLink;
	if (!campaign) {
		// Placeholder with same dimensions to prevent layout shift on iOS
		logoLink = (
			<NavStyles.LogoLink href="/home">
				<CampaignStyles.Logo
					src={logo}
					alt="logo"
					loading="eager"
					fetchpriority="high"
				/>
				<div tw="w-16 h-16 mr-3" />
				<div>
					<CampaignStyles.MainTitle>LightRainAir</CampaignStyles.MainTitle>
					<CampaignStyles.Theme>&nbsp;</CampaignStyles.Theme>
				</div>
			</NavStyles.LogoLink>
		);
	} else {
	    logoLink = (
		<NavStyles.LogoLink href="/home">
			<CampaignStyles.Logo
				src={campaign.logo ? `https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/${campaign.logo}.png` : logo}
				alt="logo"
				loading="eager"
				fetchpriority="high"
			/>
			<div>
				<CampaignStyles.MainTitle>LightRainAir</CampaignStyles.MainTitle>
				<CampaignStyles.Theme>
					{campaign.slogan}
				</CampaignStyles.Theme>
			</div>
		</NavStyles.LogoLink>
		);
	}

	return (
		<HeaderStyles.Header className={className || "header-light"}>
			<NavStyles.DesktopNavLinks css={collapseBreakpointCss.desktopNavLinks}>
				{logoLink}
				{links}
			</NavStyles.DesktopNavLinks>

			<NavStyles.MobileNavLinksContainer
				css={collapseBreakpointCss.mobileNavLinksContainer}
			>
				{logoLink}
				{links.length > 0 && (
					<>
						<NavStyles.MobileNavLinks
							initial={{ x: "150%", display: "hidden" }}
							animate={animation}
							css={collapseBreakpointCss.mobileNavLinks}
							>
							{links}
						</NavStyles.MobileNavLinks>
						<NavStyles.NavToggle
							onClick={toggleNavbar}
							className={showNavLinks ? "open" : "closed"}
							>
							{showNavLinks ? (
								<CloseIcon tw="w-6 h-6" />
							) : (
								<MenuIcon color="#ffffff" tw="w-6 h-6" />
							)}
						</NavStyles.NavToggle>
					</>
				)}
			</NavStyles.MobileNavLinksContainer>
		</HeaderStyles.Header>
	);
};
